import styled from 'styled-components';

export default styled.div<{primaryColor?: string, textColor?: string}>(
({theme, primaryColor, textColor}) => {
    return `
  --bg-color: rgba(0, 0, 0, 0.9);
  --primary-color: ${primaryColor ? primaryColor : '#444CE7'};
  --text-color: ${textColor ? textColor : '#fff'};
  --default-color: #fff;
  --hover-color: ${textColor !== '#000' ? '#fff' : '#000'};
  --radius: 4px;

  --scrollbar-thumb: rgb(31, 31, 31);
  --scrollbar-track: transparent;
  --scrollbar-thumb-hover: rgb(64, 64, 64);
 	--scrollbar-width: 4px;

  --range-track-bg: rgba(255, 255, 255, 0.20);
  --range-track-height: 5px;
  --range-thumb-height: 8px;
  --range-thumb-background: #fff;
  --primary-color-shadow: color-mix(in srgb, var(--primary-color) 15%, transparent);
  --range-thumb-shadow: 0 1px 1px var(--primary-color-shadow), 0 0 0 1px var(--primary-color-shadow);
  --range-thumb-active-shadow-width: 3px;

  height: 100%;
  width: 100%;
  position: relative;

  svg {
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
  }

  .smartplayer__container {
    position: relative;
    overflow: hidden;
    max-height: 100%;
    max-width: 100%;
    margin: 0 auto;
    aspect-ratio: var(--aspect-ratio);
  }

  .smartplayer__video {
    left: 0;
    top: 0;
    position: absolute;
    object-fit: contain;
    overflow-clip-margin: content-box;
    overflow: clip;
    width: 100%;
    height: 100%;
    z-index: 0;

    video {
      width: 100%;
      height: 100%;
    }

    .smartplayer__loader {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      color: var(--hover-color);
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      width: 40px;
      height: 40px;
      background-color: var(--bg-color);
      border-radius: var(--radius);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.smartplayer--loading {
      .smartplayer__loader {
        opacity: 1;
      }
    }

    &.smartplayer--not-loading {
      .smartplayer__loader {
        opacity: 0;
      }
    }

    &.smartplayer--airplay-connected {
      .smartplayer__videoHls {
        display: none;
      }

      .smartplayer__airplay {
        left: 0;
        top: 0;
        position: absolute;
      }
    }
  }

  .smartplayer__videoResolution {
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 2px;
    background-color: var(--bg-color);
    color: var(--default-color);
    font-size: 8px;
    z-index: 10;
    border-radius: var(--radius);
    opacity: 0;
  }

  .smartplayer__front {
    height: 100%;
    width: 100%;
  }

  .smartplayer__clickableArea {
    position: absolute;
    cursor: pointer;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
  }

  .smartplayer__clickable {
    width: 10vw;
    height: 100%;
  }

  .smartplayer__clickable--left {
    left: 0;
    background-color: transparent;
    transition: background-color 0.25s ease-out;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      opacity: 0;
      transition: opacity 0.25s ease-out;
      color: #fff;
      max-width: 32px;
      max-height: 32px;

      &:after {
        content: '10';
        font-size: 5px;
        position: absolute;
      }
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);

      .icon {
        opacity: 1;
      }
    }
  }

  .smartplayer__clickable--right {
    right: 0;
    background-color: transparent;
    transition: background-color 0.25s ease-out;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      opacity: 0;
      transition: opacity 0.25s ease-out;
      color: #fff;
      max-width: 32px;
      max-height: 32px;

      &:after {
        content: '10';
        font-size: 5px;
        position: absolute;
      }
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);

      .icon {
        opacity: 1;
      }
    }
  }

  .smartplayer__keepWatching {
    border-radius: 4px;
    padding: 32px;
    display: flex;
    gap: 24px;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    max-width: 80vw;
    background: var(--bg-color);
    cursor: default;
    z-index: 99;
  }

  .smartplayer__keepWatching--text {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin: 0;
    padding: 0;
    color: var(--default-color);
  }

  .smartplayer__keepWatching--buttons {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  .smartplayer__keepWatching--button {
    appearance: none;
    border: 0;
    display: flex;
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    color: var(--default-color);
    cursor: pointer;
  }

  .smartplayer__keepWatching--button--initial {
    background: #1F1F1F;
  }

  .smartplayer__keepWatching--button--session {
    background: #444CE7;
  }

  .smartplayer__reportErrors {
    border-radius: 4px;
    padding: 16px;
    display: flex;
    gap: 24px;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    max-width: 80vw;
    background: var(--bg-color);
    cursor: default;
    z-index: 99;
  }

  .smartplayer__reportErrorsTitle {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin: 0;
    padding: 0;
    color: var(--default-color);
  }

  .smartplayer__reportErrorsOptions {
    display: flex;
    padding-bottom: 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    color: var(--default-color);
  }

  .smartplayer__reportErrorsOption {
    display: flex;
    align-items: center;
    gap: 8px;

    input {
      margin: 0;
      padding: 0;
    }

    label {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px
    }
  }

  .smartplayer__reportErrorsButtons {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  .smartplayer__reportErrorsButton {
    appearance: none;
    border: 0;
    display: flex;
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    color: var(--default-color);
    cursor: pointer;
    background: #1F1F1F;
    width: 100%;
  }

  .smartplayer__footer {
    position: absolute;
    left: 8px;
    bottom: 8px;
    right: 8px;
    width: calc(100% - 16px);
    height: 32px;
    display: flex;
    align-items: center;
    gap: 4px;
    z-index: 91;

    &--dropdown {
      .smartplayer__footerBackDrop {
        opacity: 1;
        visibility: visible;
      }

      .smartplayer__bar-button {
        z-index: 101;
      }
    }
  }

  .smartplayer__footerBackDrop {
    content: "";
    background: rgba(0, 0, 0, 0.10);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: -48px;
    height: calc(100% + 48px);
    width: 100%;
    z-index: 99;
    opacity: 0;
    transition: opacity 0.25s ease-out, visibility: 0.1 ease-in-out;
    visibility: hidden;
  }

  .smartplayer__configuration.smartplayer__configuration--opened,
  .smartplayer__configuration.smartplayer__quality—opened,
  .smartplayer__configuration.smartplayer__velocity--opened,
  .smartplayer__configuration.smartplayer__subtitle--opened,
  .smartplayer__volume.smartplayer__volume--opened,
  .smartplayer__subtitle.smartplayer__subtitle--opened,
  .smartplayer__ai.smartplayer__ai--opened,
  .smartplayer__attachment.smartplayer__attachment--opened {
    z-index: 100;
  }

  .smartplayer__play, .smartplayer__summary, .smartplayer__controlbar {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .smartplayer__play {
    width: 56px;

    .smartplayer__button {
      height: 100%;
      width: 100%;
    }
  }

  &.smartplayer {
    .icon {
      position: absolute;
      transition: opacity 0.25s ease-out;
    }

    &.smartplayer--ended {
      .icon--loop {
        opacity: 1;
      }

      .icon--play {
        opacity: 0;
      }

      .icon--pause {
        opacity: 0;
      }
    }

    &.smartplayer--playing {
      .icon--loop {
        opacity: 0;
      }

      .icon--play {
        opacity: 0;
      }

      .icon--pause {
        opacity: 1;
      }
    }

    &.smartplayer--paused {
      .icon--loop {
        opacity: 0;
      }

      .icon--play {
        opacity: 1;
      }

      .icon--pause {
        opacity: 0;
      }

      .smartplayer--loading {
        .smartplayer__loader {
          opacity: 0;
        }
      }
    }
  }

  .smartplayer__summary {
    width: 48px;

    .smartplayer__button {
      width: 100%;
    }
  }

  .smartplayer__controlbar {
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: var(--radius);
    background: var(--bg-color);
    padding: 0 8px 0 0;
    position: relative;

    &:hover {
      .smartplayer__seekBarDuration,
      .smartplayer__seekBarCurrentTime {
        opacity: 1;
        top: -44px;
      }
    }

    @media (max-width: 768px) {
      padding: 0 8px;
    }

    &--empty {
      background-color: transparent;
    }
  }

  &.smartplayer--video-with-summary {
    .smartplayer__controlbar {
      width: calc(100% - 48px - 56px);
    }
  }

  &.smartplayer--summary-active {
    .smartplayer__search {
      display: none;
    }

    .smartplayer__configurationItem--subtitle {
      display: none;
    }
  }

  &.smartplayer--video-without-summary {
    .smartplayer__summary {
      display: none;
    }

    .smartplayer__controlbar {
      width: calc(100% - 56px);
    }
  }

  @keyframes slide-up-and-fade-in-volume {
    0% {
      transform: translateY(0); /* Iniciar com a caixa 88px abaixo */
      opacity: 0; /* Iniciar com opacidade 0 (invisível) */
      visibility: hidden;
    }
    35% {
      transform: translateY(-1); /* Iniciar com a caixa 88px abaixo */
      opacity: 0; /* Iniciar com opacidade 0 (invisível) */
      visibility: visible;
    }
    100% {
      visibility: visible;
      transform: translateY(-120px); /* Terminar com a caixa no topo */
      opacity: 1; /* Terminar com opacidade 1 (visível) */
    }
  }

  @keyframes slide-up-and-fade-in-subtitle {
    0% {
      transform: translateY(0); /* Iniciar com a caixa 88px abaixo */
      opacity: 0; /* Iniciar com opacidade 0 (invisível) */
      visibility: hidden;
    }
    35% {
      transform: translateY(-1); /* Iniciar com a caixa 88px abaixo */
      opacity: 0; /* Iniciar com opacidade 0 (invisível) */
      visibility: visible;
    }
    100% {
      visibility: visible;
      transform: translateY(calc(-100% - 32px)); /* Terminar com a caixa no topo */
      opacity: 1; /* Terminar com opacidade 1 (visível) */
    }
  }

  .smartplayer__controlbar {
    .smartplayer__dropdownContainer,
    .smartplayer__dropdownContainerQuality,
    .smartplayer__dropdownContainerVelocity,
    .smartplayer__dropdownContainerSubtitle {
      position: absolute;
      outline: none;
      cursor: pointer;
      display: flex;
      justify-content: center;
      background-color: var(--bg-color);
      border: 0;
      border-radius: var(--radius);
      left: 0px;
      opacity: 0;
      visibility: hidden;
      box-sizing: border-box;
      z-index: 100;
    }

    .smartplayer__volume {
      position: relative;
      padding: 8px 4px 8px 8px;

      .smartplayer__bar-button {
        padding: 0;
      }

      @media (max-width: 583px) {
        display: none;
      }
    }

    .smartplayer__volumeIconBox {
      display: block;
      width: 24px;
      height: 24px;
      position: relative;

      .icon {
        position: absolute;
        left: 0;
        justify-content: flex-start;

        svg {
          max-width: 24px !important;
          position: absolute;
          left: 0;
        }
      }

      .icon.icon--muted {
        position: absolute;
        left: -2px;
      }

      .icon.icon--high {
        position: absolute;
        left: -1px;
      }

      .icon.icon--low {
        position: absolute;
        left: -4px;
      }

      .icon.icon--medium {
        position: absolute;
        left: -2px;

        svg {
          max-width: 24px !important;
          position: absolute;
          left: -1px;
        }
      }
    }

    .smartplayer__volume .smartplayer__dropdownContainer {
      width: 36px;
      height: 88px;
    }

    .smartplayer__volumeRangeContainer {
      position: relative;
      width: 12px;
      height: 72px;
      margin-top: 8px;
      margin-bottom: 8px;
    }

    .smartplayer__volumeRange {
      -webkit-appearance: none;
      appearance: none;

      width: 72px;
      height: 4px;
      cursor: pointer;
      outline: none;
      border-radius: var(--radius);
      position: absolute;
      left: 0;
      bottom: 0;
      rotate: -90deg;
      transition: background 450ms ease-in;
      transform-origin: left;
      transform: translate(-2px, 6px);
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      transition: height 0.15s ease-out, width 0.15s ease-out;

      &::-moz-range-thumb {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        cursor: ew-resize;
        background-color: #FFFFFF !important;
        border: 0;
        outline: 0;
        transition: height 0.15s ease-out, width 0.15s ease-out;
      }

      &::-webkit-slider-thumb {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        cursor: eh-resize;
        background-color: #FFFFFF !important;
        border: 0;
        outline: 0;
        transition: height 0.15s ease-out, width 0.15s ease-out;
      }

      &:hover {
        height: 6px;

        &::-moz-range-thumb {
          width: 12px;
          height: 12px;
        }

        &::-webkit-slider-thumb {
          width: 12px;
          height: 12px;
        }
      }
    }

    .smartplayer__volume.smartplayer__volume--opened .smartplayer__dropdownContainer {
      animation: slide-up-and-fade-in-volume .3s ease-in-out;
      visibility: visible;
      transform: translateY(-120px);
      opacity: 1;
    }

    .smartplayer__subtitle {

    }

    .smartplayer__subtitle.smartplayer__subtitle--opened .smartplayer__dropdownContainer {
      visibility: visible;
      left: calc(100% - 280px);
      opacity: 1;
      width: 100vw;
      max-width: 280px;
      max-height: 55vh;
    }

     .smartplayer__controlbarActions .smartplayer__subtitle.smartplayer__subtitle--opened .smartplayer__dropdownContainer {
      animation: slide-up-and-fade-in-subtitle .3s ease-in-out;
      transform: translateY(calc(-100% - 32px));
    }

    .smartplayer__dropdownContainer {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-flow: column nowrap;
    }

    .smartplayer__subtitleList {
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      border-radius: var(--radius);
      background: var(--bg-color);
      box-sizing: border-box;
      transition: background-color 0.25s ease-out;
    }

    .smartplayer__subtitleItem {
      padding: 8px 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      transition: background-color 0.25s ease-out;
      color: var(--default-color);
      box-sizing: border-box;
      width: 100%;

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }

      label {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 4px;
        width: 100%;
      }

      input:checked + label > .smartplayer__subtitleItemBox {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.7489 7.96496C18.0837 8.29974 18.0837 8.84343 17.7489 9.17821L10.8925 16.0346C10.5577 16.3694 10.0141 16.3694 9.67928 16.0346L6.25109 12.6064C5.9163 12.2716 5.9163 11.7279 6.25109 11.3931C6.58587 11.0584 7.12956 11.0584 7.46435 11.3931L10.2872 14.2134L16.5383 7.96496C16.8731 7.63017 17.4168 7.63017 17.7516 7.96496H17.7489Z" fill="white"/></svg>');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 24px;
      }
    }

    .smartplayer__subtitleItem input {
      display: none;
    }
  }

  .smartplayer__subtitleItemBox,
  .smartplayer__configurationCheck {
    display: block;
    width: 24px;
    height: 24px;
  }

  .smartplayer__button {
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    appearance: none;
    display: flex;
    padding: 4px 16px;
    align-items: flex-start;
    justify-content: center;
    text-align: center;
    gap: 4px;
    border-radius: var(--radius);
    background: var(--bg-color);
    color: var(--default-color);
    border: 0;
    outline: 0;
    box-sizing: border-box;
    cursor: pointer;
    transform: translateZ(0);
    transition: opacity .25s ease-out, background-color 40ms ease-in-out, color 40ms  ease-in-out;

    &:hover,
    &:focus-visible {
      color: var(--hover-color);
      background: var(--primary-color);
      outline: 0;
      box-shadow: none;
    }
  }

  .smartplayer__bar-button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 12px;
    cursor: pointer;
    color: var(--default-color);
    background: transparent;
    border: 0;
    outline: 0;
    transition: color 40ms ease-in-out;
    z-index: 101;

    &:disabled,
    &[disabled] {
      opacity: 0.5;
      color: var(--default-color);
      cursor: not-allowed;

      &:hover {
        color: var(--default-color);
      }
    }

    &:focus-visible {
      outline: 0;
    }

    &:hover {
      color: var(--primary-color);
    }
  }

  .icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      max-width: 16px;
      max-height: 16px;
    }
  }

  .smartplayer__seekBarContainer {
    width: 100%;
  }

  .smartplayer__seekBar {
    position: relative;
  }

  .smartplayer__seek {
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    color: var(--primary-color);
    border: 0;
    border-radius: 26px;
    display: block;
    margin: 0;
    min-width: 0;
    padding: 0;
    transition: box-shadow .3s ease;
    width: 100%;
    position: absolute;
    top: 50%;
    margin-top: calc((var(--range-track-height) / 2) * -1);
    height: var(--range-track-height);
    z-index: 3;
  }

  .smartplayer__seek:hover {
    cursor: pointer;

    &::-webkit-slider-thumb {
      margin-top: calc((var(--range-thumb-height, 13px) + 5px - var(--range-track-height,5px))/2*-1);
      height: calc(var(--range-thumb-height, 13px) + 5px);
      width: calc(var(--range-thumb-height, 13px) + 5px);
    }

    &:-moz-range-thumb {
      margin-top: calc((var(--range-thumb-height, 13px) + 5px - var(--range-track-height,5px))/2*-1);
      height: calc(var(--range-thumb-height, 13px) + 5px);
      width: calc(var(--range-thumb-height, 13px) + 5px);
    }

    &:-ms-thumb {
      margin-top: calc((var(--range-thumb-height, 13px) + 5px - var(--range-track-height,5px))/2*-1);
      height: calc(var(--range-thumb-height, 13px) + 5px);
      width: calc(var(--range-thumb-height, 13px) + 5px);
    }

    & + .smartplayer__seekBarCurrentTime {
      transform: translateX(calc(-50% + 4px));
    }
  }

  .smartplayer__seek::-webkit-slider-runnable-track {
    background: transparent;
    background-image: linear-gradient(90deg,currentColor 0,transparent 0);
    background-image: linear-gradient(to right,currentColor var(--value,0),transparent var(--value,0));
    border: 0;
    border-radius: 2.5px;
    border-radius: calc(var(--range-track-height,5px)/2);
    height: 5px;
    height: var(--range-track-height,5px);
    -webkit-transition: box-shadow .3s ease;
    transition: box-shadow .3s ease;
    -webkit-user-select: none;
    user-select: none;
  }

  .smartplayer__seek::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background: #fff;
    background: var(--range-thumb-background,#fff);
    border: 0;
    border-radius: 100%;
    box-shadow: 0 1px 1px #23282f26,0 0 0 1px #23282f33;
    box-shadow: var(--range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);
    height: 13px;
    height: var(--range-thumb-height, 13px);
    margin-top: -4px;
    margin-top: calc((var(--range-thumb-height, 13px) - var(--range-track-height,5px))/2*-1);
    position: relative;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    width: 13px;
    width: var(--range-thumb-height, 13px);
  }

  .smartplayer__seek::-moz-range-track {
    background: transparent;
    border: 0;
    border-radius: 2.5px;
    border-radius: calc(var(--range-track-height,5px)/2);
    height: 5px;
    height: var(--range-track-height,5px);
    -moz-transition: box-shadow .3s ease;
    transition: box-shadow .3s ease;
    user-select: none;
  }

  .smartplayer__seek::-moz-range-thumb {
    background: #fff;
    background: var(--range-thumb-background,#fff);
    border: 0;
    border-radius: 100%;
    box-shadow: 0 1px 1px #23282f26,0 0 0 1px #23282f33;
    box-shadow: var(--range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);
    height: 13px;
    height: var(--range-thumb-height,13px);
    position: relative;
    -moz-transition: all .2s ease;
    transition: all .2s ease;
    width: 13px;
    width: var(--range-thumb-height,13px);
  }

  .smartplayer__seek::-moz-range-progress {
    background: currentColor;
    border-radius: 2.5px;
    border-radius: calc(var(--range-track-height,5px)/2);
    height: 5px;
    height: var(--range-track-height,5px);
  }

  .smartplayer__seek::-ms-track {
    color: transparent;
  }

  .smartplayer__seek::-ms-fill-upper,.smartplayer__seek::-ms-track {
    background: transparent;
    border: 0;
    border-radius: 2.5px;
    border-radius: calc(var(--range-track-height,5px)/2);
    height: 5px;
    height: var(--range-track-height,5px);
    -ms-transition: box-shadow .3s ease;
    transition: box-shadow .3s ease;
    user-select: none;
  }

  .smartplayer__seek::-ms-fill-lower {
    background: transparent;
    background: currentColor;
    border: 0;
    border-radius: 2.5px;
    border-radius: calc(var(--range-track-height,5px)/2);
    height: 5px;
    height: var(--range-track-height,5px);
    -ms-transition: box-shadow .3s ease;
    transition: box-shadow .3s ease;
    user-select: none;
  }

  .smartplayer__seek::-ms-thumb {
      background: #fff;
      background: var(--range-thumb-background,#fff);
      border: 0;
      border-radius: 100%;
      box-shadow: 0 1px 1px #23282f26,0 0 0 1px #23282f33;
      box-shadow: var(--range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);
      height: 13px;
      height: var(--range-thumb-height,13px);
      margin-top: 0;
      position: relative;
      -ms-transition: all .2s ease;
      transition: all .2s ease;
      width: 13px;
      width: var(--range-thumb-height,13px);
  }

  .smartplayer__seek::-ms-tooltip {
      display: none;
  }

  .smartplayer__seek::-moz-focus-outer {
      border: 0;
  }

  .smartplayer__seek:focus {
      outline: 0;
  }

  .smartplayer__seek:focus-visible::-webkit-slider-runnable-track {
      outline: 2px dashed #00b2ff;
      outline: 2px dashed var(--primary-color-color,var(--primary-color,var(--primary-color,#00b2ff)));
      outline-offset: 2px;
  }

  .smartplayer__seek:focus-visible::-moz-range-track {
      outline: 2px dashed #00b2ff;
      outline: 2px dashed var(--primary-color-color,var(--primary-color,var(--primary-color,#00b2ff)));
      outline-offset: 2px;
  }

  .smartplayer__seek:focus-visible::-ms-track {
      outline: 2px dashed #00b2ff;
      outline: 2px dashed var(--primary-color-color,var(--primary-color,var(--primary-color,#00b2ff)));
      outline-offset: 2px;
  }

  .smartplayer__seekBarDuration,
  .smartplayer__seekBarCurrentTime {
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -4px;
      margin-left: -4px;
      border-width: 4px;
      border-style: solid;
      border-radius: 0px 0px 2px;
      transform: rotate(45deg);
    }

    top: -28px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 12px 0px;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    padding: 4px;
    width: 48px;
    z-index: 1;
    border-radius: 4px;
    pointer-events: none;
    text-align: center;
    position: absolute;
    transition: top ease-in-out 0.2s, left ease-in-out 0.2s, right ease-in-out 0.2s, transform ease-in-out 0.2s, opacity ease-in-out 0.3s;
    opacity: 0;
  }

  .smartplayer__seekBarDuration {
    &::after {
      border-color: transparent var(--bg-color) var(--bg-color) transparent;
    }

    background: var(--bg-color);
    color: var(--default-color);
    right: -24px;
  }

  .smartplayer__seekBarCurrentTime {
    &::after {
      border-color: transparent var(--default-color) var(--default-color) transparent;
    }

    background: var(--default-color);
    color: var(--bg-color);
    z-index: 2;
    transform: translateX(calc(-50% + 2px));
  }

  // Estilos para múltiplas seekbars de capítulos
  .smartplayer__chaptersContainer {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 2px; // Gap entre capítulos
    pointer-events: auto; // Garantir que eventos funcionem no container
  }

  // HIERARQUIA VISUAL DAS MÚLTIPLAS SEEKBARS:
  // Z-Index 1: Background cinza (não carregado) - smartplayer__chapterBg
  // Z-Index 2: Buffer branco translúcido (streaming) - smartplayer__chapterBuffer
  // Z-Index 3: Progresso azul (reprodução) - smartplayer__chapterSeek

  .smartplayer__chapterContainer {
    position: relative;
    height: 100%;
    transition: transform 0.1s ease;
    pointer-events: auto; // Garantir que eventos de mouse funcionem

    &:first-child {
      .smartplayer__chapterBg,
      .smartplayer__chapterBuffer,
      .smartplayer__chapterSeek::-webkit-slider-runnable-track,
      .smartplayer__chapterSeek::-moz-range-track {
        border-top-left-radius: calc(var(--range-track-height, 5px) / 2);
        border-bottom-left-radius: calc(var(--range-track-height, 5px) / 2);
      }
    }

    &:last-child {
      .smartplayer__chapterBg,
      .smartplayer__chapterBuffer,
      .smartplayer__chapterSeek::-webkit-slider-runnable-track,
      .smartplayer__chapterSeek::-moz-range-track {
        border-top-right-radius: calc(var(--range-track-height, 5px) / 2);
        border-bottom-right-radius: calc(var(--range-track-height, 5px) / 2);
      }
    }

    // Feedback visual sutil para capítulos inativos
    &:hover:not(:has(.smartplayer__chapterSeek--active)) {
      transform: scale(1.02);

      .smartplayer__chapterBg {
        background-color: rgba(255, 255, 255, 0.15);
      }
    }

    // Destaque para o capítulo ativo
    &:has(.smartplayer__chapterSeek--active) {
      .smartplayer__chapterBg {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }

  .smartplayer__chapterSeek {
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    color: var(--primary-color); // Cor azul do progresso
    border: 0;
    border-radius: calc(var(--range-track-height, 5px) / 2);
    display: block;
    margin: 0;
    padding: 0;
    width: 100%;
    height: var(--range-track-height, 5px);
    position: relative;
    z-index: 3; // Acima do buffer (z:2) e background (z:1)
    cursor: pointer;
    pointer-events: auto !important; // GARANTIR que os clicks funcionem

    &::-webkit-slider-runnable-track {
      background: transparent;
      background-image: linear-gradient(to right, currentColor var(--value, 0), transparent var(--value, 0));
      border: 0;
      border-radius: calc(var(--range-track-height, 5px) / 2);
      height: 100%;
      width: 100%;
      cursor: pointer;
    }

    &::-moz-range-track {
      background: transparent;
      border: 0;
      border-radius: calc(var(--range-track-height, 5px) / 2);
      height: 100%;
      width: 100%;
      cursor: pointer;
    }

    // MÚLTIPLOS CAPÍTULOS: SEM BOLINHA - apenas progress visual
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      background: transparent; // Completamente invisível
      border: 0;
      border-radius: 100%;
      height: 0; // Altura zero
      width: 0; // Largura zero
      margin-top: 0;
      position: relative;
      cursor: pointer;
      opacity: 0 !important; // Força invisível
      pointer-events: none !important; // Sem interações
      display: none !important; // Esconder completamente
    }

    &::-moz-range-thumb {
      background: transparent; // Completamente invisível
      border: 0;
      border-radius: 100%;
      height: 0; // Altura zero
      width: 0; // Largura zero
      position: relative;
      cursor: pointer;
      opacity: 0 !important; // Força invisível
      pointer-events: none !important; // Sem interações
      display: none !important; // Esconder completamente
    }

    &::-moz-range-progress {
      background: currentColor;
      border-radius: calc(var(--range-track-height, 5px) / 2);
      height: 100%;
    }

    // REMOVER TODAS AS REGRAS DE ATIVO/INATIVO - não há mais bolinha para mostrar/esconder
    // Manter apenas as regras de hover para feedback visual sutil
    &:hover {
      &::-webkit-slider-runnable-track {
        background-color: rgba(255, 255, 255, 0.1);
        transition: background-color 0.2s ease;
      }

      &::-moz-range-track {
        background-color: rgba(255, 255, 255, 0.1);
        transition: background-color 0.2s ease;
      }
    }
  }

  .smartplayer__chapterBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.1); // Cor de fundo padrão (não carregada)
    border-radius: calc(var(--range-track-height, 5px) / 2);
    z-index: 1;
    transition: background-color 0.2s ease;
  }

  .smartplayer__chapterBuffer {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: transparent !important;
    color: rgba(255, 255, 255, 0.3); // Cor do buffer/streaming quando carregado
    border: 0 !important;
    border-radius: calc(var(--range-track-height, 5px) / 2);
    height: 100%;
    left: 0;
    padding: 0;
    position: absolute;
    top: 0;
    z-index: 2;
    width: 100%;

    // Esconder completamente quando não há valor
    &[value="0"],
    &[value="0.0"],
    &[value=""] {
      opacity: 0 !important;
      visibility: hidden !important;
      display: none !important; // Força esconder completamente
    }

    // Também esconder se o valor é muito baixo
    &[value="0.1"],
    &[value="0.01"] {
      opacity: 0 !important;
      visibility: hidden !important;
    }

    &::-webkit-progress-bar {
      background: transparent !important; // Fundo transparente para mostrar o background cinza
      border-radius: calc(var(--range-track-height, 5px) / 2);
      border: none !important;
      -webkit-appearance: none;
    }

    &::-webkit-progress-value {
      background: currentColor; // Usa a cor definida no color (rgba branco 30%)
      border-radius: calc(var(--range-track-height, 5px) / 2);
      min-width: 0; // Permitir largura 0
      transition: width 0.2s ease;
      border: none !important;
    }

    // Mozilla - mais restritivo
    &::-moz-progress-bar {
      background: currentColor; // Usa a cor definida no color (rgba branco 30%)
      border-radius: calc(var(--range-track-height, 5px) / 2);
      min-width: 0; // Permitir largura 0
      transition: width 0.2s ease;
      border: none !important;
    }

    // Microsoft
    &::-ms-fill {
      background: currentColor; // Usa a cor definida no color (rgba branco 30%)
      border-radius: calc(var(--range-track-height, 5px) / 2);
      transition: width 0.2s ease;
      border: none !important;
    }

    // Remover qualquer indicador visual padrão do browser
    &::-ms-track {
      background: transparent !important;
      border: none !important;
    }

    &::-ms-thumb {
      display: none !important; // Esconder qualquer thumb que possa aparecer
      opacity: 0 !important;
    }

    // Firefox - garantir que não há thumb
    &::-moz-range-thumb {
      display: none !important;
      opacity: 0 !important;
    }

    // Webkit - garantir que não há thumb
    &::-webkit-slider-thumb {
      display: none !important;
      opacity: 0 !important;
    }

    // Garantir que não há nenhum pseudo-elemento aparecendo
    &::before,
    &::after {
      display: none !important;
    }
  }

  // Tooltip individual de cada capítulo (centralizada no capítulo específico)
  .smartplayer__chapterTooltip {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%; // Centralizada no capítulo específico
    transform: translateX(-50%);
    background: var(--default-color); // Fundo branco (igual tooltip do progresso)
    color: var(--bg-color); // Letra preta (igual tooltip do progresso)
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600; // Mesma espessura da tooltip do progresso
    white-space: nowrap;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 12px 0px; // Mesmo shadow da tooltip do progresso
    z-index: 20; // Acima de todos os outros elementos
    pointer-events: none;
    opacity: 1;
    visibility: visible;
    transition: opacity 0.2s ease, visibility 0.2s ease;

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 4px solid transparent;
      border-top-color: var(--default-color); // Mesma cor do fundo
    }
  }

  // Display do capítulo atual para múltiplas seekbars (MANTER para compatibilidade, mas não usado)
  .smartplayer__currentChapter {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background: var(--bg-color);
    color: var(--default-color);
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    z-index: 10;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    pointer-events: none;

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 4px solid transparent;
      border-top-color: var(--bg-color);
    }
  }

  // Remover hover global - agora cada capítulo tem sua própria tooltip
  // .smartplayer__seekBar:hover {
  //   .smartplayer__currentChapter {
  //     opacity: 1;
  //     visibility: visible;
  //   }
  // }

  .smartplayer__bg {
    top: 50%;
    margin-top: calc((var(--range-track-height) / 2) * -1);
    position: absolute;
    width: 100%;
    height: var(--range-track-height);
    z-index: 1;
    background-color: var(--range-track-bg);
    border-radius: 100px;
  }

  .smartplayer__buffer {
    -webkit-appearance: none; /* stylelint-disable-line */
    background: transparent;
    color: var(--range-track-bg);
    border: 0;
    border-radius: 100px;
    height: var(--range-track-height);
    left: 0;
    margin-top: calc((var(--range-track-height) / 2) * -1);
    padding: 0;
    position: absolute;
    top: 50%;
    z-index: 2;
    width: 100%;

    &::-webkit-progress-bar {
      background: transparent;
    }

    &::-webkit-progress-value {
      background: currentColor;
      border-radius: 100px;
      min-width: var(--range-track-height);
      transition: width 0.2s ease;
    }

    // Mozilla
    &::-moz-progress-bar {
      background: currentColor;
      border-radius: 100px;
      min-width: var(--range-track-height);
      transition: width 0.2s ease;
    }

    // Microsoft
    &::-ms-fill {
      border-radius: 100px;
      transition: width 0.2s ease;
    }
  }

  .smartplayer__fullscreen {
    .icon {
      transition: opacity 0.25s ease-out;
    }
  }

  .smartplayer__fullscreen--active {
    .icon.icon--open-fullscreen {
      opacity: 0;
    }

    .icon.icon--close-fullscreen {
      opacity: 1;
    }
  }

  .smartplayer__fullscreen--inactive {
    .icon.icon--open-fullscreen {
      opacity: 1;
    }

    .icon.icon--close-fullscreen {
      opacity: 0;
    }
  }

  .smartplayer__pip--active {
    .icon.icon--pip-active {
      opacity: 1;
    }

    .icon.icon--pip-inactive {
      opacity: 0;
    }
  }

  .smartplayer__pip--inactive {
    .icon.icon--pip-active {
      opacity: 0;
    }

    .icon.icon--pip-inactive {
      opacity: 1;
    }
  }

  .smartplayer__airplay--active {
    .icon.icon--airplay-active {
      opacity: 1;
    }

    .icon.icon--airplay-inactive {
      opacity: 0;
    }
  }

  .smartplayer__airplay--inactive {
    .icon.icon--airplay-active {
      opacity: 0;
    }

    .icon.icon--airplay-inactive {
      opacity: 1;
    }
  }

  .smartplayer__pip {
    .smartplayer__bar-button {
      padding: 12px;
    }
  }

  .subicon.subicon--wide {
    position: relative;
    display: flex;
    align-items: center;
    height: 12px;

    & > svg {
      max-height: 18px;
      max-width: 20px;
    }

    .subicon.subicon--wide-box {
      position: absolute;
      right: 0px;
      bottom: 1px;
      background-color: currentcolor;
      width: 10px;
      height: 5px;
      border-radius: 1px;
    }

    .subicon.subicon--complete-box {
      position: absolute;
      left: 2px;
      top: 2px;
      background-color: currentcolor;
      width: 16px;
      height: 8px;
      border-radius: 0px;
    }
  }

  .smartplayer__clickable.smartplayer__clickable--center {
    width: 80%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    transition: opacity 0.25s ease-out;
    color: var(--primary-color);
  }

  &.smartplayer--playing .smartplayer__clickable.smartplayer__clickable--center {
    opacity: 0;
  }

  &.smartplayer--paused .smartplayer__clickable.smartplayer__clickable--center {
    opacity: 1;
  }

  &.smartplayer--autoplaying .smartplayer__clickable.smartplayer__clickable--center {
    opacity: 1;
  }

  @keyframes smartplayer-fade-in {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
  }

  .smartplayer__captions {
    animation: smartplayer-fade-in .3s ease;
    transform: translateY(calc(10px * -4));
    padding: calc(10px * 2);
    bottom: 0;
    left: 15%;
    right: 15%;
    position: absolute;
    text-align: center;
    transition: transform .4s ease-in-out;
    width: 70%;
    box-sizing: border-box;
  }

  .smartplayer__caption {
    line-height: 140%;
    padding: .02em .2em .10em;
    white-space: pre-wrap;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
  }

  .smartplayer__caption:empty {
    opacity: 0;
  }

  .smartplayer__captions--model-1 .smartplayer__caption{
    background-color: rgba(0, 0, 0, 0.5);
    color: rgb(255, 255, 255);
  }

  .smartplayer__captions--model-2 .smartplayer__caption{
    background-color: rgba(0, 0, 0, 0);
    color: rgb(255, 255, 255);
    text-shadow: rgb(0, 0, 0) 1px 1px 2px;
  }

  .smartplayer__captions--model-3 .smartplayer__caption{
    background-color: rgb(0, 0, 0);
    color: rgb(229, 221, 0);
  }

  .smartplayer__captions--model-4 .smartplayer__caption{
    background-color: rgba(255, 255, 255, 0);
    color: rgb(0, 0, 0);
  }

  .smartplayer__captions--font-1 .smartplayer__caption{
    font-size: 1.33333vw;
  }

  .smartplayer__captions--font-2 .smartplayer__caption{
    font-size: 2vw;
  }

  .smartplayer__captions--font-3 .smartplayer__caption{
    font-size: 2.66667vw;
  }

  .smartplayer__captions--font-4 .smartplayer__caption{
    font-size: 3.33333vw;
  }

  .smartplayer__captions--font-5 .smartplayer__caption{
    font-size: 4vw;
  }

  .smartplayer__contextMenu {
    position: absolute;
    display: flex;
    width: 220px;
    border-radius: 4px;
    color: #fff;
    border-radius: 3px;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.25s ease-out;
    visibility: hidden;
    overflow: hidden;

    & + .smartplayer__contextMenuBackdrop {
      content: "";
      background: rgba(0, 0, 0, 0.10);
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: -48px;
      height: calc(100% + 48px);
      width: 100%;
      z-index: 999;
      opacity: 0;
      transition: opacity 0.25s ease-out;
      visibility: hidden;
    }

    &.smartplayer__contextMenu--active {
      visibility: visible;
      opacity: 1;

      & + .smartplayer__contextMenuBackdrop {
        visibility: visible;
        opacity: 1;
      }
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-flow: column nowrap;
      width: 100%;
    }

    li {
      box-sizing: border-box;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 14px;
      letter-spacing: -0.24px;
      display: block;
      text-align: left;
      width: 100%;
      background: rgba(0, 0, 0, 0.9);
      transition: background-color 0.25s ease-out;

      &: hover {
        background: rgba(0, 0, 0, 0.8);
      }
    }

    a {
      box-sizing: border-box;
      color: #fff;
      text-decoration: none;
      display: block;
      transition: background-color 0.25s ease-out;
      padding: 12px;
      width: 100%;
    }
  }

  .smartplayer__bigPlay {
    color: var(--primary-color);
  }

  .smartplayer__logo {
    height: 32px;
    padding: 4px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    background-color: var(--primary-color);
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 4px 8px;

      .smartplayer__logoBig {
        display: none;
      }

      .smartplayer__logoSmall {
        display: block;
      }
    }

    @media (min-width: 769px) {
      .smartplayer__logoBig {
        display: block;
      }

      .smartplayer__logoSmall {
        display: none;
      }
    }
  }

  .smartplayer__ai.smartplayer__ai--opened,
  .smartplayer__attachment.smartplayer__attachment--opened,
  .smartplayer__configuration.smartplayer__configuration--opened,
  .smartplayer__configuration.smartplayer__quality--opened,
  .smartplayer__configuration.smartplayer__velocity--opened,
  .smartplayer__configuration.smartplayer__subtitle--opened {
    &:before {
      content: "";
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.10);
      z-index: 100;
    }
  }

  .smartplayer__ai.smartplayer__ai--opened .smartplayer__dropdownContainer {
    visibility: visible;
    left: calc(100% - 280px);
    opacity: 1;
    width: 100vw;
    max-width: 280px;
    max-height: 55vh;
  }

   .smartplayer__controlbarActions .smartplayer__ai.smartplayer__ai--opened .smartplayer__dropdownContainer {
    animation: slide-up-and-fade-in-subtitle .3s ease-in-out;
    transform: translateY(calc(-100% - 32px));
  }

  .smartplayer__attachment.smartplayer__attachment--opened .smartplayer__dropdownContainer {
    visibility: visible;
    left: calc(100% - 280px);
    opacity: 1;
    width: 100vw;
    max-width: 280px;
    max-height: 55vh;
  }

   .smartplayer__controlbarActions .smartplayer__attachment.smartplayer__attachment--opened .smartplayer__dropdownContainer {
    animation: slide-up-and-fade-in-subtitle .3s ease-in-out;
    transform: translateY(calc(-100% - 32px));
  }

  .smartplayer__dropdownContainer {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-flow: column nowrap;
  }

  .smartplayer__aiList {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: var(--radius);
    background: var(--bg-color);
    box-sizing: border-box;
    transition: background-color 0.25s ease-out;
  }

  .smartplayer__aiItem {
    padding: 8px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.25s ease-out;
    color: var(--default-color);
    box-sizing: border-box;
    width: 100%;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    label {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      width: 100%;
    }

    input + label > .smartplayer__aiItemBox {
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="7.5" viewBox="0 0 320 512" fill="%23fff"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px;
    }
  }

  .smartplayer__aiItemBox {
    display: block;
    width: 24px;
    height: 24px;
  }

  .smartplayer__aiItem input {
    display: none;
  }

  .smartplayer__attachmentList {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: var(--radius);
    background: var(--bg-color);
    box-sizing: border-box;
    transition: background-color 0.25s ease-out;
  }

  .smartplayer__attachmentItem {
    padding: 8px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.25s ease-out;
    color: var(--default-color);
    box-sizing: border-box;
    width: 100%;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    label {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      width: 100%;
    }

    input + label > .smartplayer__attachmentItemBox {
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="7.5" viewBox="0 0 320 512" fill="%23fff"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px;
    }
  }

  .smartplayer__attachmentItemBox {
    display: block;
    width: 24px;
    height: 24px;
  }

  .smartplayer__attachmentItem input {
    display: none;
  }

  .smartplayer__configuration {

  }

  .smartplayer__configuration.smartplayer__configuration--opened .smartplayer__dropdownContainer {
    visibility: visible;
    left: calc(100% - 280px);
    opacity: 1;
    width: 100vw;
    max-width: 280px;
    max-height: 55vh;
  }

   .smartplayer__controlbarActions .smartplayer__configuration.smartplayer__configuration--opened .smartplayer__dropdownContainer {
    animation: slide-up-and-fade-in-subtitle .3s ease-in-out;
    transform: translateY(calc(-100% - 32px));
  }

  .smartplayer__configuration.smartplayer__quality--opened .smartplayer__dropdownContainerQuality,
  .smartplayer__configuration.smartplayer__velocity--opened .smartplayer__dropdownContainerVelocity,
  .smartplayer__configuration.smartplayer__subtitle--opened .smartplayer__dropdownContainerSubtitle {
    visibility: visible;
    left: calc(100% - 280px);
    opacity: 1;
    width: 100vw;
    max-width: 280px;
    max-height: 55vh;
  }

   .smartplayer__controlbarActions .smartplayer__configuration.smartplayer__quality--opened .smartplayer__dropdownContainerQuality,
   .smartplayer__controlbarActions .smartplayer__configuration.smartplayer__velocity--opened .smartplayer__dropdownContainerVelocity,
   .smartplayer__controlbarActions .smartplayer__configuration.smartplayer__subtitle--opened .smartplayer__dropdownContainerSubtitle {
    animation: slide-up-and-fade-in-subtitle .3s ease-in-out;
    transform: translateY(calc(-100% - 32px));
  }

  .smartplayer__dropdownContainer,
  .smartplayer__dropdownContainerQuality,
  .smartplayer__dropdownContainerVelocity,
  .smartplayer__dropdownContainerSubtitle {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-flow: column nowrap;
  }

  .smartplayer__configurationList,
  .smartplayer__subConfigurationList {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: var(--radius);
    background: var(--bg-color);
    box-sizing: border-box;
    transition: background-color 0.25s ease-out;
  }

  .smartplayer__subConfigurationHeader {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 13px 20px;
    border-bottom: 1px solid #595959;
    width: 100%;
  }

  .smartplayer__subConfigurationBack {
    height: 24px;
    width: 24px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    background-color: transparent;
    border-color: transparent;
    outline: 0;

    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' height='12' width='7.5' viewBox='0 0 320 512'%3E%3Cpath d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px;
  }

  .smartplayer__subConfigurationList {
    & > .smartplayer__configurationItem,
    & > .smartplayer__configurationItem label {
      justify-content: flex-start;
    }
  }

  .smartplayer__subConfigurationTitle {
    color: #fff;
    margin: 0;
    text-align: center;
    width: calc(100% - 48px);
    font-size: 14px;
    font-weight: 600;
  }

  .smartplayer__configurationItem {
    padding: 8px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.25s ease-out;
    color: var(--default-color);
    box-sizing: border-box;
    width: 100%;
    font-size: 14px;
    font-weight: 500;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    label {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      width: 100%;
      color: #FFF;
    }

    .smartplayer__configurationItemTitle {
      font-size: 14px;
      font-weight: 600;
    }

    .smartplayer__configurationItemValue {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .smartplayer__configurationItemValueText {
      color: #FFF;
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      font-size: 12px;
      font-weight: 500;
    }

    .smartplayer__configurationItemBox {
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="7.5" viewBox="0 0 320 512" fill="%23fff"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px;
    }

    input:checked + label > .smartplayer__configurationCheck {
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.7489 7.96496C18.0837 8.29974 18.0837 8.84343 17.7489 9.17821L10.8925 16.0346C10.5577 16.3694 10.0141 16.3694 9.67928 16.0346L6.25109 12.6064C5.9163 12.2716 5.9163 11.7279 6.25109 11.3931C6.58587 11.0584 7.12956 11.0584 7.46435 11.3931L10.2872 14.2134L16.5383 7.96496C16.8731 7.63017 17.4168 7.63017 17.7516 7.96496H17.7489Z" fill="white"/></svg>');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 24px;
    }
  }

  .smartplayer__configurationItemBox {
    display: block;
    width: 24px;
    height: 24px;
  }

  .smartplayer__configurationItem input {
    opacity: 0;
    height: 0;
    width: 0;
    visibility: hidden;
  }
}

.smartplayer__controlbar--hidden {
  display: none !important;
}

.smartplayer__footerFakeProgressBar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  z-index: 100;
}

`;
  });
